import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getSimilarItemIds } from '@/redux/modules/similarSoldItemsV3';
import ItemShelf from '@/components/ItemShelf/ItemShelf';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

type Props = {
    className?: string;
    itemId: number;
};

/*
    This component expects that the data for the items is fetched elsewhere rather than in the component
*/
const SimilarSoldItems = ({ className, itemId }: Props) => {
    const itemIds = useSelector((state) => getSimilarItemIds(state, itemId));

    return (
        <StyledItemShelf
            className={className}
            hideLiveButton
            identifier="soldOnLiveAuctioneers"
            itemIds={itemIds}
            showSoldBadge
            title={<FormattedMessage id="soldItemCarousel.title" />}
        />
    );
};

export default React.memo<Props>(SimilarSoldItems);

const StyledItemShelf = styled(ItemShelf)`
    margin: 25px -20px 0;
`;
